import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { StyledBannerMessage, StyledOfferMessageContainer } from "../SplitpayBanner.styles";
import { SPLIT_PAY_BANNER_TEST_ID } from "@swiggy-private/payment-test-ids";

interface ShowMessagesProps {
    showOfferMessage: boolean;
    showBannerMessage: boolean;
    showDisableMessage: boolean;
    offerMessage?: string;
    bannerMessage?: string;
    disableMessage?: string;
}

const ShowMessages: React.FC<ShowMessagesProps> = ({
    showOfferMessage,
    showBannerMessage,
    showDisableMessage,
    offerMessage,
    bannerMessage,
    disableMessage,
}) => {
    return (
        <>
            {showOfferMessage && (
                <StyledOfferMessageContainer>
                    <Text
                        data-testid={SPLIT_PAY_BANNER_TEST_ID.OFFER_MESSAGE}
                        color="text_Med_Emphasis"
                        variant="V2.overline.neutral.medium"
                    >
                        {offerMessage}
                    </Text>
                </StyledOfferMessageContainer>
            )}
            {showBannerMessage && (
                <StyledBannerMessage
                    data-testid={SPLIT_PAY_BANNER_TEST_ID.BANNER_MESSAGE}
                    color="text_Low_Emphasis"
                    variant="V2.body3.neutral.regular"
                >
                    {bannerMessage}
                </StyledBannerMessage>
            )}
            {showDisableMessage && (
                <Text
                    data-testid={SPLIT_PAY_BANNER_TEST_ID.DISABLE_MESSAGE}
                    color="negative"
                    variant="V2.body3.neutral.regular"
                >
                    {disableMessage}
                </Text>
            )}
        </>
    );
};

export default memo(ShowMessages);
